var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard" },
    [
      _c(
        "v-container",
        { staticClass: "py-0 px-0", attrs: { "grid-list-xs": "" } },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-card",
                    { staticClass: "info-box" },
                    [
                      _c(
                        "v-container",
                        { staticClass: "py-3", attrs: { fluid: "" } },
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "px-4 py-2",
                              attrs: {
                                "align-center": "",
                                "justify-space-between": "",
                                row: "",
                                "fill-height": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "box-dataClient px-2",
                                  attrs: { sm8: "", md7: "", lg8: "" }
                                },
                                [
                                  _vm.isSeller
                                    ? [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v("Hola,\n"),
                                          _c("strong", [_vm._v("Vendedor")])
                                        ])
                                      ]
                                    : _vm._e(),
                                  _vm.isSupervisor
                                    ? [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v("Hola,\n"),
                                          _c("strong", [_vm._v("Supervisor")])
                                        ])
                                      ]
                                    : _vm._e(),
                                  _vm.isBoss
                                    ? [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v("Hola,\n"),
                                          _c("strong", [_vm._v("Jefe")])
                                        ])
                                      ]
                                    : _vm._e(),
                                  _vm.isAdmin
                                    ? [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v("Hola,\n"),
                                          _c("strong", [
                                            _vm._v("Administrador")
                                          ])
                                        ])
                                      ]
                                    : _vm._e(),
                                  _c("h1", [
                                    _vm.notificationCount > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "on-hold-notification"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.notificationCount > 99
                                                  ? "+99"
                                                  : _vm.notificationCount
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "label",
                                      {
                                        style: {
                                          "padding-left":
                                            _vm.notificationCount > 0
                                              ? "30px"
                                              : "0"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.user.firstName) + "   "
                                        )
                                      ]
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.user.lastName) + " ")
                                    ])
                                  ]),
                                  _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(_vm.today))
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs3: "" } },
                [
                  _c(
                    "v-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.onSubmit($event)
                        }
                      }
                    },
                    [
                      _c("v-layout", [
                        _c("h2", { staticClass: "title mb-5" }, [
                          _vm._v(" Datos Obligatorios")
                        ])
                      ]),
                      _c(
                        "v-layout",
                        { attrs: { xs1: "" } },
                        [
                          _c("v-flex", [
                            _c("img", {
                              staticClass: "mr-2",
                              attrs: {
                                src: require("assets/icons/Info_Circle_line.png")
                              }
                            })
                          ]),
                          _c("v-flex", [
                            _c("span", [
                              _vm._v(
                                "Recuerda que tienes un límite de consultas al día."
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { "mt-3": "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("label", { staticClass: "sub-title" }, [
                                _vm._v("RUC")
                              ]),
                              _c("v-text-field", {
                                model: {
                                  value: _vm.ruc,
                                  callback: function($$v) {
                                    _vm.ruc =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "ruc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            [
                              _c("label", { staticClass: "sub-title" }, [
                                _vm._v("Solución")
                              ]),
                              _c("v-select", {
                                attrs: {
                                  items: _vm.solutionName,
                                  "item-text": "name"
                                },
                                on: { input: _vm.selectSolucion },
                                model: {
                                  value: _vm.solucion,
                                  callback: function($$v) {
                                    _vm.solucion = $$v
                                  },
                                  expression: "solucion"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", [
                            _c(
                              "div",
                              { staticClass: "business-data__content_ mt-2" },
                              [
                                _c("label", { staticClass: "sub-title" }, [
                                  _vm._v("Giro comercial")
                                ]),
                                _c(
                                  "autocomplete",
                                  {
                                    staticClass: "my-3",
                                    attrs: {
                                      options: _vm.opCommercialBusiness,
                                      label: "Description",
                                      "component-item": _vm.template
                                    },
                                    on: {
                                      change: _vm.listenerAutocomplete,
                                      input: function($event) {
                                        _vm.consultGiro($event && $event.Code)
                                      }
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "option",
                                        fn: function(option) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "option__select" },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(option.Code))
                                                ]),
                                                _c("span", [_vm._v("- ")]),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "option__description"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(option.Description)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.giro,
                                      callback: function($$v) {
                                        _vm.giro = $$v
                                      },
                                      expression: "giro"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "no-options" },
                                        slot: "no-options"
                                      },
                                      [_vm._v("Sorry, no matching options.")]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        {
                          staticClass: "mt-2",
                          attrs: { "justify-center": "" }
                        },
                        [
                          _c("vue-recaptcha", {
                            ref: "recaptcha",
                            attrs: { sitekey: _vm.sitekey },
                            on: { verify: _vm.onVerify, expired: _vm.onExpired }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        {
                          staticClass: "mt-2",
                          attrs: { "justify-center": "" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-button orange",
                              attrs: {
                                block: "",
                                type: "submit",
                                disabled:
                                  _vm.loading ||
                                  _vm.$v.$invalid ||
                                  _vm.buttonDisabled ||
                                  _vm.expiredCaptchaToken
                              }
                            },
                            [
                              !_vm.loading
                                ? _c("span", [_vm._v("CALCULAR COMISIONES ")])
                                : _c("v-progress-circular", {
                                    attrs: {
                                      size: "25",
                                      indeterminate: "",
                                      color: "white"
                                    }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("loader", {
                    ref: "loaderModal",
                    attrs: { text: "Realizando validación" }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { staticStyle: { height: "120px" }, attrs: { xs9: "" } },
                [
                  _c("v-layout", { staticStyle: { height: "120px" } }),
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        "align-center": "",
                        "justify-start": "",
                        column: "",
                        "fill-height": "",
                        "ml-5": ""
                      }
                    },
                    [
                      _vm.showMessage
                        ? _c(
                            "h2",
                            { staticClass: "ml-3 title-ruc-carterizado" },
                            [_vm._v(_vm._s(_vm.errorMessage))]
                          )
                        : _vm._e(),
                      _vm.showTableComision ? _c("comisions") : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bf48b87", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bf48b87","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/commisionPreviewer.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4bf48b87","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/commisionPreviewer.vue
// module chunks = 17